module.exports = __webpack_public_path__ + "img/three-dots.cb4a7179.svg";